import { render, staticRenderFns } from "./EditOrderItem.vue?vue&type=template&id=0219fa27"
import script from "./EditOrderItem.vue?vue&type=script&lang=js"
export * from "./EditOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports